module.exports = __webpack_public_path__ + "static/media/Telus_One_page-02.e13a3ff4.png";